import formDataConstructor from './formDataConstructor';

const API_BASE = 'https://whitefriars.glass/api';
const ENDPOINTS = {
  memory: {
    path: '/memory',
    method: 'POST',
  },
  general: {
    path: '/feedback',
    method: 'POST',
  },
  contact: {
    path: '/feedback',
    method: 'POST',
  },
  newItem: {
    path: '/item',
    method: 'POST',
  },
  editItem: {
    path: '/item/:id',
    method: 'POST',
  },
  images: {
    path: '/item/:id',
    method: 'POST',
  },
};

const sendRequest = (url, method, formData) =>
  new Promise((resolve, reject) => {
    console.log('[sendRequest] Building XHR request');
    var XHR = new XMLHttpRequest();

    console.log('[sendRequest] Binding response event handlers');
    XHR.addEventListener('load', event => {
      console.log('[sendRequest] Request response loaded');
      resolve(XHR.responseText);
    });
    XHR.addEventListener('error', event => {
      console.log('[sendRequest] Request response failed');
      reject(event);
    });

    console.log('[sendRequest] Setting target endpoint details');
    XHR.open(method, url);

    console.log('[sendRequest] Sending data payload');
    console.log(formData);
    XHR.send(formData);

    console.log('[sendRequest] Sent');
  });

export default function submissionRequestHandler(
  formName,
  itemId,
  formDataSource
) {
  console.log('[submissionRequestHandler] Constructing request');

  console.log('[submissionRequestHandler] Get target endpoint details');
  const url = `${API_BASE}${ENDPOINTS[formName].path.replace(':id', itemId)}`;
  const method = ENDPOINTS[formName].method;

  console.log(
    '[submissionRequestHandler] Constructing data payload from source:',
    formDataSource
  );
  const formData = formDataConstructor(
    formDataSource.fields,
    formDataSource.images
  );

  console.log('[submissionRequestHandler] Calculating request size');
  const contentLength = Array.from(formData.entries()).reduce(
    (total, entry) =>
      total + (typeof entry[1] === 'string' ? entry[1].length : entry[1].size),
    0
  );

  // If content length is near of above 6MB the submission will be rejected by AWS Lambda.
  // Above 10MB AWS API Gateway will reject it.
  if (contentLength > 6000000) {
    console.log(
      '[submissionRequestHandler] Request length too large:',
      contentLength
    );
    return Promise.resolve({ error: true, errorCode: 'REQUEST_TOO_LARGE' });
  } else {
    console.log('[submissionRequestHandler] Sending request');
    return sendRequest(url, method, formData)
      .then(response => {
        console.log('[submissionRequestHandler] Response loaded:', response);
        return JSON.parse(response);
      })
      .then(json => {
        console.log('[submissionRequestHandler] JSON loaded:', json);
        return json && json.status === 'success';
      })
      .catch(error => {
        console.log('[submissionRequestHandler] Error occurred:', error);
        return false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/components/contribution-form/submissionRequestHandler.js